$giper_baza_app_stat_list $mol_book2_catalog
	menu_title \📊 Network Monitoring
	param \peer
	Spread* $giper_baza_app_stat_page
		home <= peer_home* $giper_baza_app_home
			urls => peer_urls*
		uptime => peer_uptime*
		tools /
			<= Spread_close
	menu_link_content* /$mol_view_content
		<= Menu_link_avatar* $mol_avatar
			id <= peer_uri* \
		<= Menu_link_title*
		<= Menu_link_status* $mol_view
			sub / <= peer_uptime*
